import { z } from 'zod'

import { AiImproverGoal } from 'apps/aiTextImprover/lib/types'

const GenerateTextRequestSchema = z.object({
  description: z.string(),
  tone_of_voice: z.string(),
  language: z.string().optional(),
  flow_ns: z.string().nullable(),
})

const ImproveTextRequestSchema = z.object({
  source: z.string(),
  goal: z.enum(AiImproverGoal),
  goal_value: z.string().nullable(),
  flow_ns: z.string().nullable(),
})

const AnyAiGeneratorRequestSchema = GenerateTextRequestSchema.or(ImproveTextRequestSchema)

export const GenerateTextSchema = {
  request: GenerateTextRequestSchema,
  query: z.undefined(),
  path: z.undefined(),
  response: z.object({
    messages: z.array(z.string()),
  }),
}

export const ImproveTextSchema = {
  request: ImproveTextRequestSchema,
  query: z.undefined(),
  path: z.undefined(),
  response: z.object({
    message: z.string(),
  }),
}

export type GenerateTextRequestData = z.infer<typeof GenerateTextRequestSchema>
export type ImproveTextRequestData = z.infer<typeof ImproveTextRequestSchema>
export type AnyAiGeneratorRequestData = z.infer<typeof AnyAiGeneratorRequestSchema>
